// eslint-disable-next-line
export default new (class AboutUsModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.order = data.attributes.order || "";
    model.type = data.attributes.Content[0].__component || "";
    model.title_en = data.attributes.section_title_EN || "";
    model.title_th = data.attributes.section_title_TH || "";
    model.content = data.attributes.Content || [];

    return model;
  }
})();
